import { dropdownValuesService } from "services";

let requestCache:
	| {
			id: string | number;
			name: string;
	  }[]
	| null = null;

const loadProcessors = async (search, prevOptions, { page }) => {
	try {
		if (requestCache === null || search.length === 0) {
			requestCache = await dropdownValuesService.getProcessors();
		}

		return {
			options: requestCache?.filter(item =>
				item?.name?.toLowerCase()?.includes(search?.toLowerCase()),
			),
			hasMore: false,
			additional: {
				page: page + 1,
			},
		};
	} catch {
		return { options: [] };
	}
};

const processorColumn = () => ({
	name: "processor",
	type: "select" as const,
	loadOptions: loadProcessors,
	getOptionLabel: option => option.name,
	getOptionValue: option => option.id,
	placeholder: "Processor",
});

export default processorColumn;
